import React, {useState} from 'react';
import {Button, Card, Skeleton, Table} from "antd";
import {useSelector} from "react-redux";
import {useGetRolesQuery} from "../../../../slices/rootApiSlices/roleApiSlice";
import RoleAddModal from "./RoleAddModal";
import RoleUpdateModal from "./RoleUpdateModal";
import moment from "moment/moment";

const Index = () => {

    const {user} = useSelector(state => state.auth);
    const {data, isLoading, error} = useGetRolesQuery(user?.token);

    const [isAddModalVisible, setIsAddModalVisible] = useState(false);
    const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
    const [selectedRoleId, setSelectedRoleId] = useState(null);

    const handleOpenModal = () => {
        setIsAddModalVisible(true);
    };

    const handleCloseModal = () => {
        setIsAddModalVisible(false);
    };

    const handleUpdateOpenModal = (roleId) => {
        setSelectedRoleId(roleId);
        setIsUpdateModalVisible(true);
    };

    const handleUpdateCloseModal = () => {
        setIsUpdateModalVisible(false);
    };


    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text, row) => (
                <Button type="link" size="small" onClick={() => handleUpdateOpenModal(row.id)}>
                    {text ? text : "-"}
                </Button>
            ),
        },
        {
            title: 'Oluşturma Tarihi',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text) => (
                <span>
                    {moment(text).format('DD.MM.YYYY - HH:mm')}
                </span>
            ),
        },
        {
            title: 'Güncelleme Tarihi',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            render: (text) => (
                <span>
                    {moment(text).format('DD.MM.YYYY - HH:mm')}
                </span>
            ),
        },
    ];


    return (
        <>
            <Card
                size="small"
                title="Rol Listesi"
                type="inner"
                extra={
                    <Button type="link" onClick={handleOpenModal} size="small">
                        + Yeni Rol Oluştur
                    </Button>
                }
            >
                <Skeleton loading={isLoading}>
                    <Table
                        loading={isLoading}
                        size="small"
                        bordered={true}
                        columns={columns}
                        rowKey="id"
                        pagination={false}
                        dataSource={data?.data}
                        error={error}
                    />
                </Skeleton>
            </Card>
            <RoleAddModal visible={isAddModalVisible} onClose={handleCloseModal}/>
            <RoleUpdateModal visible={isUpdateModalVisible} onClose={handleUpdateCloseModal} data={selectedRoleId}/>
        </>
    );

};

export default Index;
